<template>
  <section class="flex justify-between gap-8 mt-24">
    <div class="selection-wrapper w-full flex-col self-end">
      <h1 class="text-h3 lg:text-h2 mb-8 break-all">Hello, {{ account.firstName }}</h1>
      <ProfileEditMenu :profile-account-data="profileAccountData" />
    </div>
    <div class="relative">
      <Avatar :image-url="account.croppedPhoto" :photo-status="account.photoStatus" :size="AvatarSize.MEGA" :name="sitterName" />
      <router-link
        class="primary-focus flex justify-center items-center w-32 h-32 rounded-full bg-grey-divider-subdued !absolute top-64 right-0"
        :to="{ name: 'provider-photo-upload' }"
        :aria-label="noProfilePhoto ? 'Add profile photo' : 'Edit profile photo'"
      >
        <AddIcon v-if="noProfilePhoto || account.photoStatus === 'REJECTED'" :width="32" :height="32" />
        <PhotoIcon v-else :width="16" :height="16" color="#4B4C52" />
      </router-link>
    </div>
  </section>
</template>

<script lang="ts">
import { Account } from '@/models/account';
import ProfileEditMenu from './ProfileEditMenu.vue';
import Avatar, { AvatarSize } from '@/components/avatar/Avatar.vue';
import PhotoIcon from '@/graphics/icons/PhotoIcon.vue';
import AddIcon from '@/graphics/icons/AddIcon.vue';

export default {
  name: 'ProfileEdit',
  components: { ProfileEditMenu, Avatar, PhotoIcon, AddIcon },
  props: {
    account: {
      required: true,
      type: Account,
    },
    profileAccountData: {
      required: true,
      type: Object,
    },
  },
  data(): any {
    return {
      AvatarSize,
    };
  },
  computed: {
    sitterName(): string {
      return `${this.account?.firstName} ${this.account?.lastName}`;
    },
    noProfilePhoto(): boolean {
      return !this.account.croppedPhoto;
    },
  },
};
</script>
